import { useMemo } from 'react'
import { Box } from '@mui/system'
import {
  Edit,
  SimpleForm,
  TextInput,
  Toolbar as RaToolbar,
  SaveButton,
  PasswordInput,
  useRedirect,
  minLength,
  required,
  FunctionField,
  useTranslate,
} from 'react-admin'
import { useLabel, useNotifyResponse } from '../../../hooks'
import { capitalize } from '../../../util'

const Toolbar = props => (
  <RaToolbar {...props}>
    <SaveButton />
  </RaToolbar>
)

const resource = 'users'

const validatePassword = [required(), minLength(8)]

const UsersEdit = () => {
  const translate = useTranslate()
  const resourceName = useMemo(() => {
    return capitalize(translate(`resources.${resource}.name`, {
      smart_count: 1,
    }))
  }, [translate])
  const { notifySuccess, notifyFailure } = useNotifyResponse({ resourceName })
  const redirect = useRedirect()
  const label = useLabel({ resource })

  return (
    <Edit
      resource={resource}
      id={'0'}
      mutationMode='pessimistic'
      mutationOptions={{
        onSuccess: () => {
          notifySuccess('updated')
          redirect('/')
        },
        onError: (error) => {
          notifyFailure(error)
        }
      }}
    >
      <SimpleForm toolbar={<Toolbar />}>
        <Box sx={{ maxWidth: 500 }}>
          <TextInput source='email' label={label('email')} disabled />
          <FunctionField render={record => {
            return (
              !record.has_temp_password &&
              <PasswordInput source='old_password' validate={required()} label={label('old_password')} />
            )
          }} />
          <PasswordInput source='password' validate={validatePassword} label={label('new_password')} />
        </Box>
      </SimpleForm>
    </Edit>
  )
}

export default UsersEdit
